export default __webpack_public_path__ + "static/newsletter-890d1a245a08b9d4e09312ab8a66606b.jpg";